// Unpublished Work © 2022-2026 Deere & Company.

import {getEquipmentJobHistory} from 'Services/equipment-service';
import {dateCompare, genericServiceCompare, numericCompare} from 'Ui/models/maintenance';
import {formatDateOrDefault, formatNumberOrDefault} from 'OnEquip/equipment/utils/equipment-detail-formatters';
import {formatRouteWithCustomHoles} from 'Ui/models/job-model';

export async function getRowData(equipment, translations) {
    if (equipment?.equipmentId) {
        const {jobHistory} = await getEquipmentJobHistory(equipment.equipmentId);

        return jobHistory.map((historyEntry) => ({
            ...historyEntry,
            formattedDateSelect: formatDateOrDefault(historyEntry.dateSelect),
            route: formatRouteWithCustomHoles(historyEntry.route, historyEntry.routeCustomDefn, translations),
            formattedActualDuration: formatNumberOrDefault(historyEntry.actualDuration, 1)
        }));
    }

    return [];
}

export function getColumns(translations) {
    return [
        {
            headerName: translations.DATE,
            valueGetter: (_value, row) => row,
            field: 'formattedDateSelect',
            width: 120,
            sortComparator: (a, b) => {
                return genericServiceCompare(a, b, dateCompare, 'dateSelect');
            },
            renderCell: (params) => {
                return params.row.formattedDateSelect;
            }
        },
        {
            headerName: translations.ONLINK_ROUTE,
            minWidth: 150,
            flex: 1,
            field: 'route'
        },
        {
            headerName: translations.jobs_job,
            minWidth: 150,
            flex: 1,
            field: 'jobTitle'
        },
        {
            headerName: translations.OPERATOR,
            minWidth: 150,
            flex: 1,
            field: 'operator'
        },
        {
            headerName: translations.ONLINK_JOB_DURATION,
            minWidth: 150,
            flex: 1,
            field: 'actualDuration',
            type: 'number',
            valueGetter: (_value, row) => row,
            sortComparator: (a, b) => {
                return genericServiceCompare(a, b, numericCompare, 'actualDuration');
            },
            renderCell: (params) => {
                return params.row.formattedActualDuration;
            }
        }
    ];
}
